import React, { Suspense, useCallback, useContext, useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { TostMsg } from "../../../App";
import {
  getTicketListData,
  addTicket,
  addObserver,
  deleteTicketObserverListData,
  addTicketAttachmentData,
  deleteTicketAttachmentData,
} from "./TicketService";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import {
  GetMasterTypeData,
  uploadDoc,
} from "../../../Services/Global-Services/GlobalServices";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { AutoComplete } from "primereact/autocomplete";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { PostDate } from "../Dashboard/CommonComponents/PostDate";
import moment from "moment";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import UploadFile_KEYS from "../../../Services/Global-Services/UploadFile_Keys";
const ComponentLoader = React.lazy(() =>
  import("../../../Shared/Sidebar/ComponentLoader")
);
const defaultImage = "/images/placeholder_profile.png";
function TicketDetail() {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const { RequestNumber } = useParams();
  const [ticketDetailsData, setTicketDetailsData] = useState([]);
  const [ticketHistoryDetailsData, setTicketHistoryDetailsData] = useState([]);
  const [showFirstDetailsOfHistory, setShowFirstDetailsOfHistory] = useState(
    []
  );
  const [tickeObservertDetailsData, setTicketObserverDetailsData] = useState(
    []
  );
  const toster = useContext(TostMsg);
  const [Isloading, setIsloading] = useState(false);
  const [selectedEmployees, setSelectedEmployees] = useState(null);
  const [employeDetails, setEmployeeDetails] = useState([]);
  const [observers, setObservers] = useState([]);
  const [selectedObservers, setSelectedObservers] = useState(null);
  const [filteredObservers, setFilteredObservers] = useState(null);
  const [showAllDocvisible, setShowAllDocvisible] = useState(false);
  const [showAllDelete, setShowAllDelete] = useState({
    show: false,
    type: "",
  });
  const [deleteTicketItemId, setDeleteTicketItemId] = useState(0);
  const [ticketMasterDataList, setTicketMasterDataList] = useState([]);
  const [deleteContent, setDeleteContent] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [selectedServerity, setSelectedServerity] = useState(null);
  const [selectedPriority, setSelectedPriority] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [description, setDescription] = useState("");
  const [RequestTitle, setRequestTitle] = useState("");
  const [ticketNotificationId, setTicketNotificationId] = useState(0);
  const [ticketStatusType, setTicketStatusType] = useState([]);
  const [ticketCategoryType, setTicketCategoryType] = useState([]);
  const [ticketSubcategoryType, setTicketSubcategoryType] = useState([]);
  const [ticketSubcategoryTypeSelected, setTicketSubcategoryTypeSelected] =
    useState([]);
  const [ticketPriorityType, setTicketPriorityType] = useState([]);
  const [ticketSeverityType, setTicketSeverityType] = useState([]);
  const history = useHistory();
  let ticketId;
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");

  const panelFooterTemplate = () => {
    const isObserversSelected = (filteredObservers || []).some(
      (country) => country["FullName"] === selectedObservers
    );
    return (
      <div className="py-2 px-3">
        {isObserversSelected ? (
          <span>
            <b>{selectedObservers}</b> selected.
          </span>
        ) : (
          "No Observers selected."
        )}
      </div>
    );
  };

  useEffect(() => {
    getMasterTicketStatus();
    getMasterTicketCategory();
    getMasterTicketSubCategory();
    getMasterTicketPriority();
    getMasterTicketSeverity();
    fetchEmployeeIdData();
    if (RequestNumber?.length <= 4) {
      setTicketNotificationId(Number(RequestNumber));
    } else {
      getTicketData();
    }
  }, []);

  async function getTicketData() {
    let ticketNo;
    if (ticketNotificationId) {
      ticketNo = "";
    }
    setIsloading(true);
    const param = {
      OrgId: userDetails?.OrgId,
      LoggedInEmpId: userDetails?.EmpId,
      RaisedByEmpId: "",
      AssignedToId: "",
      TicketId: ticketId ?? 0,
      RequestStatusId: "",
      RequestCategoryId: "",
      RequestSubCategoryId: "",
      PriorityId: "",
      SeverityId: "",
      Search: "",
      filterStartDate: "",
      filterEndDate: "",
      PageNumber: 1,
      PageSize: 10,
      IsDeleted: 0,
      RequestNumber: ticketNo ?? RequestNumber,
    };
    try {
      const data = await getTicketListData(param);
      let ticketDetailData = await data?.Data?.OrgEmpRequests;
      setTicketDetailsData(ticketDetailData);
      setTicketObserverDetailsData(ticketDetailData[0]?.ObserverLists);
      setTicketHistoryDetailsData(ticketDetailData[0]?.RequestHistory);
      setIsloading(false);
    } catch {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  const updateTicketValidation = Yup.object().shape({
    comment: Yup.string(),
    docPath: Yup.string(),
    AssignedToId: Yup.string(),
  });

  const updateTicketForm = useFormik({
    initialValues: {
      comment: "",
      docPath: "",
      AssignedToId: "",
    },
    validationSchema: updateTicketValidation,
    onSubmit: async (data) => {
      let commentValue;
      setIsloading(true);
      const existing = ticketDetailsData[0];
      const AssignedToEmpId = selectedEmployees?.EmpId;
      updateTicketForm.setFieldValue("AssignedToId", AssignedToEmpId);
      const updatedFieldData = {
        ticketId: existing?.Id,
        RequestTitle: RequestTitle,
        RequestDescription: description,
        RequestCategoryId: selectedCategory,
        RequestSubCategoryId: selectedSubCategory,
        Severity: selectedServerity,
        Priority: selectedPriority,
        RequestStatusId: selectedStatus,
      };
      const body = {
        Id: updatedFieldData?.ticketId || 0,
        IsDeleted: 0,
        RequestNumber: RequestNumber,
        OrgId: userDetails?.OrgId,
        EmpId: existing?.EmpId, //userDetails?.EmpId,
        RequestTitle: updatedFieldData?.RequestTitle || existing?.RequestTitle,
        RequestDescription:
          updatedFieldData?.RequestDescription || existing?.RequestDescription,
        RequestCategoryId:
          updatedFieldData?.RequestCategoryId || existing?.RequestCategoryId,
        RequestSubCategoryId:
          updatedFieldData?.RequestSubCategoryId ||
          existing?.RequestSubCategoryId,
        Comment: data?.comment,
        Severity: updatedFieldData?.Severity || existing?.Severity,
        Priority: updatedFieldData?.Priority || existing?.Priority,
        AssignedToId: AssignedToEmpId,
        RequestStatusId:
          updatedFieldData?.RequestStatusId || existing?.RequestStatusId,
      };
      if (data.comment) {
        commentValue = "";
      } else {
        commentValue = "";
      }
      const hasChanged =
        body.RequestTitle !== existing?.RequestTitle ||
        body.RequestDescription !== existing?.RequestDescription ||
        body.RequestCategoryId !== existing?.RequestCategoryId ||
        body.RequestSubCategoryId !== existing?.RequestSubCategoryId ||
        body.Severity !== existing?.Severity ||
        body.Priority !== existing?.Priority ||
        body.AssignedToId !== existing?.AssignedToId ||
        body.RequestStatusId !== existing?.RequestStatusId ||
        body.Comment !== commentValue;
      if (!hasChanged) {
        setIsloading(false);
        toster.current.warn("No changes detected.");
        return;
      }
      try {
        const createGallary = await addTicket(body);
        if (createGallary) {
          GetMasterSystemAlertList("Ticket_Updated", 0);
          if (userDetails?.EmpId === existing?.AssignedToId) {
            history.push(`/Ticket`);
          }
          updateTicketForm.resetForm();
          getTicketData();
          setIsEditing(false);
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.TicketUpdate);
      } finally {
        setIsloading(false);
      }
    },
  });

  //For get the employee data.
  async function fetchEmployeeIdData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    setIsloading(true);
    try {
      let employeesList = await getEmployeeList(params);
      let employeeValidateList = [];
      employeeValidateList = employeesList.Data;
      setEmployeeDetails(employeeValidateList);
      setObservers(employeesList.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  const handleSelectionChange = (e) => {
    setSelectedEmployees(e.value);
  };

  const employeeOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage alt={option.FullName} src={option.ProfileImage} width="32" />
        <span>{option.FullName}</span>
      </div>
    );
  };

  const selectedAssignName = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
          <LazyImage
            alt={option.FullName}
            src={option.ProfileImage}
            width="32"
          />
          <span>{option.FullName}</span>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];
    uploadPolicyDocFile(selectedFile);
  };

  async function uploadPolicyDocFile(file) {
    if (file) {
      setIsloading(true);
      const formData = new FormData();
      formData.append("files", file);
      let params = {
        UploadType: UploadFile_KEYS?.Message,
        RefId: ticketDetailsData[0]?.EmpId ?? 0,
      };
      const response = await await uploadDoc(params, formData);
      const data = await response;
      const ticketFormData = data?.Data[0];
      updateAttachement(ticketFormData);
      setIsloading(false);
    } else {
      toster.current.warn("No file selected");
      setIsloading(false);
    }
  }

  const search = (event) => {
    setTimeout(() => {
      let _filteredObervers;
      if (!event.query.trim().length) {
        _filteredObervers = [...observers];
      } else {
        _filteredObervers = observers.filter((item) => {
          return item.FullName.toLowerCase().startsWith(
            event.query.toLowerCase()
          );
        });
      }
      setFilteredObservers(_filteredObervers);
    }, 250);
  };

  const itemTemplateObservers = (item) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage alt={item.FullName} src={item.ProfileImage} width="32" />
        <span>{item.FullName}</span>
      </div>
    );
  };

  async function addObserverData() {
    if (selectedObservers == null) {
      toster.current.warn("Please select at least one observer.");
    } else {
      const params = {
        CreatedBy: ticketDetailsData[0]?.EmpId,
        OrgId: selectedObservers?.OrgId,
        RequestId: ticketDetailsData[0]?.Id,
        ObserverId: selectedObservers?.EmpId,
      };
      setIsloading(true);
      try {
        const data = await addObserver(params);
        let employeesList = await data;
        GetMasterSystemAlertList("Observers_Added", 0);
        setTimeout(() => {
          getTicketData();
          setSelectedObservers(null);
        }, 1000);
        setIsloading(false);
      } catch (error) {
        setIsloading(false);
      }
    }
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  async function deleteTicketItemData() {
    if (
      deleteTicketItemId.toLocaleString().length > 0 &&
      showAllDelete.type == "Observer"
    ) {
      const body = {
        Id: deleteTicketItemId,
        ModifiedBy: ticketDetailsData[0]?.EmpId,
      };
      let ticketList = await deleteTicketObserverListData(body);
      try {
        let ticketList = await deleteTicketAttachmentData(body);
        if (ticketList) {
          getTicketData();
          setShowAllDelete(false);
          toster.current.success("Ticket  observer  deleted successfully");
          setIsloading(false);
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
        setIsloading(false);
      }
    } else if (
      deleteTicketItemId.toLocaleString().length > 0 &&
      showAllDelete.type == "Doc"
    ) {
      const body = {
        docPathId: deleteTicketItemId,
        loggedInEmpId: userDetails?.EmpId,
      };
      try {
        let ticketList = await deleteTicketAttachmentData(body);
        if (ticketList) {
          getTicketData();
          setShowAllDelete(false);
          toster.current.success("Ticket  document  deleted successfully");
          setIsloading(false);
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
        setIsloading(false);
      }
    }
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message) {
        setDeleteContent(msg?.Desc);
      }
    });
  }, []);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleCloseClick = () => {
    setIsEditing(false);
  };

  const handleChangeDescription = (e) => {
    setDescription(e.target.value);
  };

  const handleChangeTitle = (e) => {
    setRequestTitle(e.target.value);
  };

  const handleChangeStatus = (e) => {
    setSelectedStatus(e.value);
  };

  async function updateAttachement(DocPath) {
    const params = {
      OrgId: userDetails?.OrgId,
      RequestId: ticketDetailsData[0]?.Id,
      RequestDetailId: 101,
      UploadedById: userDetails?.EmpId,
      DocPath: DocPath,
    };
    try {
      const data = await addTicketAttachmentData(params);
      if (data) {
        GetMasterSystemAlertList("Ticket_Attachment_Added", 0);
        getTicketData();
      }
    } catch (error) {}
  }

  useEffect(() => {
    const requestDes = ticketDetailsData[0]?.RequestDescription || "";
    const requestTitle = ticketDetailsData[0]?.RequestTitle || "";
    setDescription(requestDes);
    setRequestTitle(requestTitle);
    const employeeToEdit = employeDetails.find(
      (employee) => employee.Id === ticketDetailsData[0]?.AssignedToId
    );
    if (employeeToEdit) {
      setSelectedEmployees(employeeToEdit);
    }
    if (ticketSubcategoryTypeSelected?.length > 0) {
      const defaultSubCategory = ticketSubcategoryTypeSelected?.find(
        (Subcategory) =>
          Subcategory.Id === ticketDetailsData[0]?.RequestSubCategoryId
      );
      if (defaultSubCategory) {
        setSelectedSubCategory(defaultSubCategory.Id);
      }
    }
    if (ticketStatusType?.length > 0) {
      const statusToEdit = ticketStatusType.find(
        (status) => status.Id === ticketDetailsData[0]?.RequestStatusId
      );
      if (statusToEdit) {
        if (statusToEdit?.Id && selectedStatus) {
          setSelectedStatus(selectedStatus);
        } else {
          setSelectedStatus(statusToEdit.Id);
        }
      }
      const defaultCategory = ticketCategoryType?.find(
        (category) => category.Id === ticketDetailsData[0]?.RequestCategoryId
      );
      const defaultServerity = ticketSeverityType?.find(
        (serverity) => serverity.Id === ticketDetailsData[0]?.Severity
      );
      const defaultPriority = ticketPriorityType?.find(
        (priority) => priority.Id === ticketDetailsData[0]?.Priority
      );

      if (defaultCategory) {
        if (defaultCategory?.Id && selectedCategory) {
          setSelectedCategory(selectedCategory);
        } else {
          setSelectedCategory(defaultCategory.Id);
        }
      }
      if (defaultServerity) {
        if (defaultServerity?.Id && selectedServerity) {
          setSelectedServerity(selectedServerity);
        } else {
          setSelectedServerity(defaultServerity.Id);
        }
      }
      if (defaultPriority) {
        if (defaultPriority?.Id && selectedPriority) {
          setSelectedPriority(selectedPriority);
        } else {
          setSelectedPriority(defaultPriority.Id);
        }
      }
    }
    if (ticketHistoryDetailsData?.length > 0) {
      let lastIndex = ticketHistoryDetailsData.length - 1;
      setShowFirstDetailsOfHistory(ticketHistoryDetailsData[lastIndex]);
    }
  }, [
    ticketDetailsData,
    employeDetails,
    selectedStatus,
    ticketMasterDataList,
    ticketHistoryDetailsData,
    ticketSubcategoryTypeSelected,
  ]);

  useEffect(() => {
    if (selectedCategory) {
      let seletedSubCat = ticketSubcategoryType.filter(
        (item) => item.CategoryId === selectedCategory
      );
      setTicketSubcategoryTypeSelected(seletedSubCat);
    }
    if (ticketNotificationId) {
      getTicketData();
    }
  }, [selectedCategory, ticketNotificationId]);

  async function getMasterTicketStatus() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "TicketStatusType",
    };
    try {
      const data = await GetMasterTypeData(params);
      setTicketStatusType(data?.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getMasterTicketCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Category",
    };
    try {
      const data = await GetMasterTypeData(params);
      setTicketCategoryType(data?.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getMasterTicketSubCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Subcategory",
    };
    try {
      const data = await GetMasterTypeData(params);
      setTicketSubcategoryType(data?.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getMasterTicketPriority() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Priority",
    };
    try {
      const data = await GetMasterTypeData(params);
      setTicketPriorityType(data?.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getMasterTicketSeverity() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Severity",
    };
    try {
      const data = await GetMasterTypeData(params);
      setTicketSeverityType(data?.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  const determineDocType = (DocData) => {
    const imageExtensions = /\.(jpg|jpeg|png|gif|bmp)$/i;
    const pdfExtension = /\.pdf$/i;

    if (imageExtensions.test(DocData)) {
      return "image";
    } else if (pdfExtension.test(DocData)) {
      return "pdf";
    } else {
      return "Doc";
    }
  };

  return (
    <div>
      <div Id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>
        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      {/* <!-- row --> */}
      <div className="container-fluid position-relation">
        <div className="row">
          <div className="col-xl-12">
            <div className="row g-3">
              <div>
                <Link to="/Ticket">
                  <button className="back-newticket w-auto float-right">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-arrow-left-short"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                      />
                    </svg>
                    Back
                  </button>
                </Link>
              </div>
              <div className="col-xl-8">
                <div className="card">
                  <div className="card-body">
                    <img
                      src="/images/org-img/leave/popup-backimg.png"
                      className="sidefloatimg"
                    />
                    {isEditing ? (
                      <h5 className="mb-0 tickno">
                        Ticket No: {ticketDetailsData[0]?.RequestNumber} |
                        <span className="status-chng">
                          {ticketDetailsData[0]?.RequestStatus}
                        </span>
                      </h5>
                    ) : (
                      <>
                        <h5 className="mb-0">
                          Ticket No: {ticketDetailsData[0]?.RequestNumber}
                        </h5>
                      </>
                    )}
                    <div className="illustration-header00">
                      <div className="header-meta">
                        <h2 className="detailhead mb-3 mt-3">
                          {isEditing ? (
                            <input
                              name="Description"
                              className={"form-control topmaintitle"}
                              onChange={handleChangeTitle}
                              value={RequestTitle}
                            />
                          ) : (
                            <>{ticketDetailsData[0]?.RequestTitle}</>
                          )}
                          {isEditing ? (
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={handleCloseClick}
                              title="Close"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                fill="currentColor"
                                className="bi bi-x"
                                viewBox="0 0 16 16"
                              >
                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                              </svg>
                            </span>
                          ) : (
                            <>
                              <img
                                src="/images/tickets/edit-ico.svg"
                                onClick={handleEditClick}
                                className="editdivinfo"
                                title="Edit"
                              />
                            </>
                          )}
                        </h2>
                        <ul className="basicinfomation basicinfomationlis">
                          <li>
                            {isEditing ? (
                              <Dropdown
                              disabled={ticketDetailsData[0]?.IsEdit === 0}
                                name="category"
                                value={selectedCategory}
                                onChange={(e) => {
                                  setSelectedCategory(e.value);
                                }}
                                options={ticketCategoryType}
                                optionLabel="Name"
                                optionValue="Id"
                                // filter
                                placeholder="Category"
                              />
                            ) : (
                              <>
                                <b>
                                  Category :{ticketDetailsData[0]?.CategoryName}
                                </b>
                              </>
                            )}
                          </li>
                          <li>
                            {isEditing ? (
                              <Dropdown
                              disabled={ticketDetailsData[0]?.IsEdit === 0}
                                name="subCategory"
                                value={selectedSubCategory}
                                onChange={(e) => {
                                  setSelectedSubCategory(e.value);
                                }}
                                options={ticketSubcategoryTypeSelected}
                                optionLabel="Name"
                                optionValue="Id"
                                // filter
                                placeholder="Sub Category"
                              />
                            ) : (
                              <>
                                <b>
                                  Sub-Category :
                                  {ticketDetailsData[0]?.SubCategoryName}
                                </b>
                              </>
                            )}
                          </li>
                          <li>
                            {isEditing ? (
                              <Dropdown
                              disabled={ticketDetailsData[0]?.IsEdit === 0}
                                name="SeverityName"
                                value={selectedServerity}
                                onChange={(e) => {
                                  setSelectedServerity(e.value);
                                }}
                                options={ticketSeverityType}
                                optionLabel="Name"
                                optionValue="Id"
                                // filter
                                placeholder="Serverity"
                              />
                            ) : (
                              <>
                                <span className="med-pri">
                                  {ticketDetailsData[0]?.SeverityName}
                                </span>
                              </>
                            )}
                          </li>
                          <li>
                            {isEditing ? (
                              <Dropdown
                              disabled={ticketDetailsData[0]?.IsEdit === 0}
                                name="priority"
                                value={selectedPriority}
                                onChange={(e) => {
                                  setSelectedPriority(e.value);
                                }}
                                options={ticketPriorityType}
                                optionLabel="Name"
                                optionValue="Id"
                                //  filter
                                placeholder="Priority"
                              />
                            ) : (
                              <>
                                <span className="priority-status">
                                  {ticketDetailsData[0]?.PriorityName}
                                </span>
                              </>
                            )}
                          </li>
                          <li>
                            {isEditing ? (
                              <span></span>
                            ) : (
                              <>
                                <span className="status-chng">
                                  {ticketDetailsData[0]?.RequestStatus}
                                </span>
                              </>
                            )}
                          </li>
                        </ul>
                        <div className="header-meta">
                          <h3 className="mb-3 mt-3">Description</h3>
                          {isEditing ? (
                            <textarea
                              name="Description"
                              className={"form-control"}
                              onChange={handleChangeDescription}
                              value={description}
                              rows="3"
                              cols="1"
                            ></textarea>
                          ) : (
                            <>
                              <p>
                                {ticketDetailsData[0]?.RequestDescription} .
                              </p>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-body">
                    <div className="commenton-ticket">
                      <form
                        className="header-meta"
                        onSubmit={updateTicketForm.handleSubmit}
                      >
                        <h3 className="mb-3">Comment</h3>
                        <textarea
                          name="comment"
                          className={
                            "form-control" +
                            (updateTicketForm.errors.comment &&
                            updateTicketForm.touched.comment
                              ? " is-invalid"
                              : "")
                          }
                          onChange={updateTicketForm.handleChange}
                          value={updateTicketForm.values.comment}
                          rows="10"
                          cols="1"
                        ></textarea>
                        <div className="ticket-details-contact__ift">
                          <div className="ticket-details-contact__ift-wrapper">
                            <label>Assigned</label>
                            <div className="assigntodiv statuschange">
                              <Dropdown
                                value={selectedEmployees}
                                onChange={(e) => {
                                  setSelectedEmployees(e.value);
                                  handleSelectionChange(e);
                                }}
                                options={employeDetails}
                                filter={true}
                                optionLabel="FullName"
                                placeholder="Select Employee"
                                itemTemplate={employeeOptionTemplate}
                                valueTemplate={selectedAssignName}
                                disabled={ticketDetailsData[0]?.IsEdit === 0}
                              />
                            </div>
                          </div>
                          <div className="ticket-details-contact__ift-wrapper">
                            <label>Status</label>
                            <div className="statuschange">
                              <Dropdown
                                value={selectedStatus}
                                onChange={handleChangeStatus}
                                options={ticketStatusType}
                                optionLabel="Name"
                                optionValue="Id"
                                placeholder="Status"
                                checkmark={true}
                                highlightOnSelect={false}
                                disabled={ticketDetailsData[0]?.IsEdit === 0}
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className=""
                          style={{ textAlign: "end", display: "block" }}
                        >
                          <button
                            className="submit-comment"
                            title=""
                            type="submit"
                            aria-label="submit"
                            fdprocessedid="rki79j"
                          >
                            Submit
                          </button>
                          <Link
                            className="close-comment"
                            title=""
                            type="button"
                            to="/Ticket"
                            aria-label="Start"
                            fdprocessedid="rki79j"
                          >
                            Cancel
                          </Link>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-body">
                    <div className="history-tl-container">
                      <h5 className="mt-0">Ticket Activity</h5>
                      <ul className="tl">
                        {ticketHistoryDetailsData?.slice(0, ticketHistoryDetailsData.length - 1)?.map((history) => {
                            const comment = history?.Comment;
                            let fileName = "";

                            if (comment.startsWith("Attachment added")) {
                              // Extract part after the backslash or slash
                              const url = comment.split(":").slice(1).join(":"); // get everything after first ":"
                              fileName = url.split("\\").pop().split("/").pop(); // handle both \ and /
                            }
                            return (
                              <li
                                className="tl-item"
                                ng-repeat="item in retailer_history"
                              >
                                <div className="item-detail">
                                  <PostDate
                                    LastCommentDate={history?.ModifiedDate}
                                  />
                                </div>
                                <div className="item-title">
                                  {history?.HistoryTitle}
                                </div>
                                <ul className="basicinfomation">
                                  <li>
                                    <b>Category : {history?.CategoryName}</b>
                                  </li>
                                  &nbsp;
                                  <li>
                                    <b>
                                      Sub-Category : {history?.SubCategoryName}
                                    </b>
                                  </li>
                                  &nbsp;
                                  <li>
                                    <span className="med-pri">
                                      {history?.SeverityName}
                                    </span>
                                  </li>
                                  &nbsp;
                                  <li>
                                    <span className="priority-status">
                                      {history?.PriorityName}
                                    </span>
                                  </li>
                                  &nbsp;
                                  <li>
                                    <span className="status-chng">
                                      {history?.RequestStatus}
                                    </span>
                                  </li>
                                  &nbsp;
                                  <li>
                                    <span className="assign-to">
                                      Assigned :
                                      <img
                                        src={history?.AssignToProfileImage}
                                      />
                                      {history?.AssignToName}
                                    </span>
                                  </li>
                                  &nbsp;
                                </ul>
                                <p className="description">
                                  <b>Description :</b>
                                  {history?.RequestDescription}
                                </p>
                                {!fileName && (
                                  <p className="commentdiv">
                                    <b>Comment :</b>
                                    {history?.Comment}
                                  </p>
                                )}
                                {fileName && (
                                  <p className="commentdiv">
                                    <b>Comment :</b>
                                    Attachment added: {fileName}
                                  </p>
                                )}
                              </li>
                            );
                          })}
                        <li
                          className="tl-item"
                          ng-repeat="item in retailer_history"
                        >
                          <div className="item-detail">
                            <PostDate
                              LastCommentDate={
                                showFirstDetailsOfHistory?.ModifiedDate
                              }
                            />
                          </div>
                          <div className="item-title">
                            Raised by
                            <a>
                              <img
                                src={ticketDetailsData[0]?.EmployeeProfileImage}
                              />
                              {ticketDetailsData[0]?.EmployeeFullName}
                            </a>
                            &nbsp;on&nbsp;
                            {moment(ticketDetailsData[0]?.ModifiedDate).format(
                              "MMM DD YYYY"
                            )}
                          </div>
                          <ul className="basicinfomation">
                            <li>
                              <b>
                                Category :
                                {showFirstDetailsOfHistory?.CategoryName}
                              </b>
                            </li>
                            <li>
                              <b>
                                Sub-Category :
                                {showFirstDetailsOfHistory?.SubCategoryName}
                              </b>
                            </li>
                            <li>
                              <span className="med-pri">
                                {showFirstDetailsOfHistory?.SeverityName}
                              </span>
                            </li>
                            <li>
                              <span className="priority-status">
                                {showFirstDetailsOfHistory?.PriorityName}
                              </span>
                            </li>
                            <li>
                              <span className="status-chng">
                                {showFirstDetailsOfHistory?.RequestStatus}
                              </span>
                            </li>
                            {showFirstDetailsOfHistory?.AssignToName && (
                              <li>
                                <span className="assign-to">
                                  Assigned :&nbsp;
                                  <img
                                    src={
                                      showFirstDetailsOfHistory?.AssignToProfileImage
                                    }
                                  />
                                  {showFirstDetailsOfHistory?.AssignToName}
                                </span>
                              </li>
                            )}
                          </ul>
                          <p className="description">
                            <b>Description :</b>
                            {showFirstDetailsOfHistory?.RequestDescription}
                          </p>
                          <p className="commentdiv">
                            <b>Comment :</b>
                            {showFirstDetailsOfHistory?.Comment}
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4">
                <div className="card">
                  <div className="card-body">
                    <div className="ticket-createdby">
                      <h5 className="mt-0">Created by</h5>
                      <div className="ticket-file-attach__wrapper">
                        <div className="option-g">
                          <div className="info mb-0">
                            <div className="info__items_detail">
                              <LazyImage
                                src={ticketDetailsData[0]?.EmployeeProfileImage}
                                alt="zip.png"
                              />
                              <div className="div">
                                <h6>
                                  {ticketDetailsData[0]?.EmployeeFullName}
                                </h6>
                                <span>
                                  On&nbsp;
                                  {moment(
                                    ticketDetailsData[0]?.CreatedDate
                                  ).format("MMM DD YYYY")}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-body">
                    <div className="ticket-createdby">
                      <h5 className="mt-0">Assigned</h5>
                      <div className="ticket-file-attach__wrapper">
                        <div className="option-g">
                          <div className="info mb-0">
                            <div className="info__items_detail">
                              <LazyImage
                                src={ticketDetailsData[0]?.AssignToProfileImage}
                                alt="zip.png"
                              />
                              <div className="div">
                                <h6>{ticketDetailsData[0]?.AssignToName}</h6>

                                {ticketDetailsData[0]?.AssignedToId > 0 && (
                                  <span>
                                    Since&nbsp;
                                    {moment(
                                      ticketDetailsData[0]?.ModifiedDate
                                    ).format("MMM DD YYYY")}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-body">
                    <div className="ticket-createdby">
                      <h5 className="mt-0">Observers</h5>
                      <div className="Observers__wrapper">
                        <div className="Observers_item drop">
                          <AutoComplete
                            field="FullName"
                            value={selectedObservers}
                            suggestions={filteredObservers}
                            completeMethod={search}
                            onChange={(e) => setSelectedObservers(e.value)}
                            itemTemplate={itemTemplateObservers}
                            panelFooterTemplate={panelFooterTemplate}
                            disabled={ticketDetailsData[0]?.IsEdit === 0}
                          />
                          {selectedObservers?.EmpId && (
                            <div className="ticket-file-attach__items_download">
                              <a
                                onClick={() => addObserverData()}
                                style={{ cursor: "pointer" }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="34"
                                  height="34"
                                  style={{ color: "black", width: "34px" }}
                                  fill="currentColor"
                                  className="bi bi-plus"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                                </svg>
                              </a>
                            </div>
                          )}
                        </div>
                        <div className="option-g">
                          {tickeObservertDetailsData?.map(
                            (observers, index) => {
                              return (
                                <div
                                  className="ticket-file-attach__items"
                                  key={index}
                                >
                                  <div className="ticket-file-attach__items_detail">
                                    <img
                                      src={
                                        observers?.ProfileImage || defaultImage
                                      }
                                      onError={handleImageError}
                                      alt="zip.png"
                                    />
                                    <div className="div">
                                      <h6>{observers?.ObserverName}</h6>
                                      <span>
                                        Since&nbsp;
                                        {moment(
                                          observers?.ObserverCreatedDate
                                        ).format("MMM DD YYYY")}
                                      </span>
                                    </div>
                                  </div>
                                  <div
                                    className="ticket-file-attach__items_download"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <a
                                      title="Delete"
                                      onClick={() => {
                                        setDeleteTicketItemId(observers?.Id);
                                        GetMasterSystemAlertList(
                                          "Observer_Delete",
                                          1
                                        );
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="13"
                                        height="13"
                                        fill="currentColor"
                                        className="bi bi-trash3 text-white"
                                        viewBox="0 0 16 16"
                                        data-bs-toggle="modal"
                                        data-bs-target="#delete-ed"
                                        onClick={() =>
                                          setShowAllDelete({
                                            show: true,
                                            type: "Observer",
                                          })
                                        }
                                      >
                                        <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                                      </svg>
                                    </a>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-body">
                    <div className="ticket-createdby">
                      <h4 className="text-primary mb-3 sumh4 addprofile-action">
                        Attachments
                        {ticketDetailsData[0]?.IsEdit === 1 && (
                          <span>
                            <a
                              className="edit-btncss mb-2 love-icon"
                              onClick={() =>
                                document.getElementById("file-upload").click()
                              }
                              title="Add"
                            >
                              <img
                                src="/images/org-img/profile/add.png"
                                className=""
                              />
                            </a>
                          </span>
                        )}
                        <input
                          type="file"
                          id="file-upload"
                          className="form-control"
                          onChange={handleFileChange}
                          name="BannerImage"
                          style={{ display: "none" }}
                        />
                      </h4>

                      <div className="ticket-file-attach__wrapper">
                        {ticketDetailsData[0]?.Attachments?.map((img) => {
                          let DocType = determineDocType(img?.DocPath);
                          return (
                            <div className="filediv">
                              <div className="file_detail">
                                <a href={img?.DocPath} target="blank">
                                  {DocType == "image" && (
                                    <LazyImage
                                      src={img?.DocPath}
                                      alt={img?.Id}
                                    />
                                  )}
                                  {DocType == "Doc" && (
                                    <img
                                      src="/images/tickets/doc.png"
                                      className="w-100"
                                      alt="Doc"
                                    />
                                  )}
                                  {DocType == "pdf" && (
                                    <div className="inner">
                                      <img
                                        src="/images/tickets/pdf.png"
                                        className="w-100"
                                        alt="Doc"
                                      />
                                    </div>
                                  )}
                                </a>
                                <span>
                                  <h6>{img?.DocName}</h6>
                                  <span className="bypersom-date">
                                    By
                                    <Link
                                      to={`/Profile/${img?.UploadedByUserGUID}`}
                                    >
                                      <img src={img?.UploadedByProfileImage} />
                                      {img?.UploadedByName}
                                    </Link>
                                    &nbsp;on&nbsp;
                                    {moment(img?.CreatedDate).format(
                                      "MMM DD YYYY"
                                    )}
                                  </span>
                                </span>
                              </div>
                              <div className="ticket-file-attach__items_download ">
                                <div className="d-flex ">
                                  <a
                                    href={img?.DocPath}
                                    target="blank"
                                    className="me-2"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="17"
                                      height="17"
                                      fill="currentColor"
                                      className="bi bi-download text-danger"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                                      <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                                    </svg>
                                  </a>
                                  <a
                                    onClick={() => {
                                      setDeleteTicketItemId(img?.Id);
                                      GetMasterSystemAlertList(
                                        "Document_Delete",
                                        1
                                      );
                                    }}
                                    title="Delete"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-trash3"
                                      viewBox="0 0 16 16"
                                      title="Delete"
                                      data-bs-toggle="modal"
                                      data-bs-target="#delete-ed"
                                      onClick={() =>
                                        setShowAllDelete({
                                          show: true,
                                          type: "Doc",
                                        })
                                      }
                                    >
                                      <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                                    </svg>
                                  </a>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        header="File Attachment"
        visible={showAllDocvisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!showAllDocvisible) return;
          setShowAllDocvisible(false);
        }}
      >
        <div className="card">
          <div className="card-body">
            <div className="review-step">
              <div className="ticket-file-attach__wrapper">
                {ticketDetailsData[0]?.Attachments?.map((docs, index) => {
                  let docMultiplePathTypeData = docs.DocPath.split("_");
                  return (
                    <div className="ticket-file-attach__items">
                      <div className="ticket-file-attach__items_detail">
                        <LazyImage src={docs.DocPath} alt="default.png" />

                        <div className="div">
                          <h6>{docMultiplePathTypeData[1]}</h6>
                          {/* <span>7.05 MB</span> */}
                        </div>
                      </div>
                      <div className="ticket-file-attach__items_download">
                        <a
                          href={docs.DocPath}
                          target="blank"
                          onClick={() => {
                            setDeleteTicketItemId(docs?.Id);
                            GetMasterSystemAlertList("Document_Delete", 1);
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="svg replaced-svg"
                          >
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                            <polyline points="7 10 12 15 17 10"></polyline>
                            <line x1="12" y1="15" x2="12" y2="3"></line>
                          </svg>
                        </a>
                        <a>
                          <img
                            style={{
                              marginLeft: "16px",
                              width: "20%",
                              padding: "5px",
                              cursor: "pointer",
                            }}
                            src="/images/org-img/delete.png"
                            className="side-delete"
                            title="Delete"
                            data-bs-toggle="modal"
                            onClick={() =>
                              setShowAllDelete({
                                show: true,
                                type: "Doc",
                              })
                            }
                          />
                        </a>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      <div className="modal fade" Id="delete-ed">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>{deleteContent}</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
                onClick={() => {
                  setShowAllDelete(false);
                  setDeleteContent([]);
                }}
              >
                Close
              </button>
              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                onClick={() => deleteTicketItemData()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      {Isloading ? (
        <Suspense >
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}

export default TicketDetail;
